export default "__VITE_ASSET__Y8DeS6lS__"